import { useNavigate } from '@tanstack/react-router';
import ToggleButtons from '@/components/buttons/ToggleButtons.tsx';
import Option from '@/components/form/types/Option.ts';
import { tourRoute } from '@/features/dashboard/tours/routes/tourRoute.ts';
import {
  FinanceView,
  financeViewLabels,
} from '@/features/dashboard/tours/routes/tourFinanceView.ts';

const OPTIONS: Option[] = Object.values(FinanceView).map((view) => ({
  value: view,
  label: financeViewLabels[view],
}));

interface FinanceViewToggleProps {
  view: FinanceView;
}

/**
 * Przełącznik przekroju finansów. Wybór idzie do adresu, a nie do stanu
 * komponentu — dzięki temu przeżywa odświeżenie i da się nim linkować
 * (panel „Wymaga uwagi” prowadzi wprost do budżetu).
 */
const FinanceViewToggle = ({ view }: FinanceViewToggleProps) => {
  const { tourId } = tourRoute.useParams();
  const navigate = useNavigate();

  return (
    <ToggleButtons
      options={OPTIONS}
      selected={view}
      onChange={(value) =>
        navigate({
          to: '/app/tours/$tourId/finances',
          params: { tourId },
          search: { view: value as FinanceView },
        })
      }
    />
  );
};

export default FinanceViewToggle;
